// extracted by mini-css-extract-plugin
module.exports = {"container":"teamMatchups_container__GZ6RV","atSymbol":"teamMatchups_atSymbol__ZXYGB"};